import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

const AUTHENTIK_URL = process.env.REACT_APP_AUTHENTIK_URL;
const CLIENT_ID = 'marketing-tracker';

const userManager = new UserManager({
  authority: `${AUTHENTIK_URL}/application/o/${CLIENT_ID}/`,
  client_id: CLIENT_ID,
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: false,
});

const authService = {
  login: () => userManager.signinRedirect(),

  handleCallback: () => userManager.signinRedirectCallback(),

  logout: () => userManager.signoutRedirect(),

  getUser: () => userManager.getUser(),

  getAccessToken: async () => {
    const user = await userManager.getUser();
    if (!user || user.expired) return null;
    return user.access_token;
  },

  clearStaleState: () => userManager.clearStaleState(),
};

export default authService;
